"use strict";

if (process.env.NODE_ENV === 'production') {
  // Display console message.
  console.log("\n   ▄████████     ███      ▄██████▄     ▄███████▄ \n  ███    ███ ▀█████████▄ ███    ███   ███    ███ \n  ███    █▀     ▀███▀▀██ ███    ███   ███    ███ \n  ███            ███   ▀ ███    ███   ███    ███ \n▀███████████     ███     ███    ███ ▀█████████▀  \n         ███     ███     ███    ███   ███        \n   ▄█    ███     ███     ███    ███   ███        \n ▄████████▀     ▄████▀    ▀██████▀   ▄████▀\n\nJe maakt nu gebruik van een browser\nfeature alleen bedoeld voor ontwik-\nkelaars. Kopieer niks in dit veld\nen sluit deze ontwikkelomgeving af.\n\nBen je een ontwikkelaar?\nhttps://www.nc-websites.nl/werken-bij-nc-websites/\n ");
}

// Import libraries.
import 'bootstrap/dist/js/bootstrap.js';
import GLightbox from 'glightbox/src/js/glightbox.js';
import jquery from 'jquery';
import Popper from 'popper.js';

// Import local.
import addScript from './_utils/addScript.js';
import addScripts from './_utils/addScripts.js';
import addStylesheet from './_utils/addStylesheet.js';
import addStylesheets from './_utils/addStylesheets.js';
import cookies from './_utils/cookies.js';
import copyText from './_utils/copyText.js';
import { deepAssign, deepEqual } from './_utils/deepObjects.js';
import EventDispatcher from './_utils/EventDispatcher.js';
import fillAddress from './_utils/fillAddress.js';
import { focusAfter, trapFocus } from './_utils/focus.js';
import { store as storeScrollPosition, restore as restoreScrollPosition } from './_utils/restoreScrollPosition.js';
import hyperscript from './_utils/hyperscript.js';
import ModalAjax from './_utils/ModalAjax.js';
import ModalPrompt from './_utils/ModalPrompt.js';
import ModalShow from './_utils/ModalShow.js';
import readdScripts from './_utils/readdScripts.js';
import scrollTo from './_utils/scrollTo.js';

// Add custom libraries.
// import NCConfetti from './misc/Confetti.js'
import NCAccessibilityFontSize from './misc/accessibilityFontSize.js';
import NCAccessibilityHighContrast from './misc/accessibilityHighContrast.js';
import NCAccessibilityMenu from './misc/accessibilityMenu.js';
import NCClearOnReset from './misc/clearFormOnReset.js';
import NCBlockResubmit from './misc/blockResubmit.js';
import NCBlockInvalidCustomSelect from './misc/blockInvalidCustomSelect.js';
import NCEqual from './misc/equal.js';
import NCIntersect from './misc/intersect.js';
import NCLoad from './misc/load.js';
import NCLightbox from './misc/lightbox.js';
import NCMarquee from './misc/marquee.js';
import { offsetAnchors as NCOffsetAnchors } from './misc/offsetAnchors.js';
import NCPreviewImages from './misc/previewImages.js';
import NCRoundabout from './misc/roundabout.js';
import NCShortenText from './misc/shortenText.js';
import NCSlider from './misc/slider.js';
import NCSpinner from './_utils/Spinner.js';
import NCUploader from './misc/Uploader.js';
import NCWizard from './misc/wizard.js';
import whappieHelper from './misc/whappie-helper.js';

// window.NCConfetti = NCConfetti
window.GLightbox = GLightbox;
window.jQuery = window.$ = jquery;
window.Popper = Popper;
window.NCBlockInvalidCustomSelect = NCBlockInvalidCustomSelect;
window.NCBlockResubmit = NCBlockResubmit;
window.NCClearOnReset = NCClearOnReset;
window.NCLightbox = NCLightbox;
window.NCMarquee = NCMarquee;
window.NCRoundabout = NCRoundabout;
window.NCSlider = NCSlider;
window.NCSpinner = NCSpinner;
window.NCUploader = NCUploader;
window.NCWizard = NCWizard;

/* Add common utility to util object. */
var util = {
  // Custom utilities.
  addScript: addScript,
  addScripts: addScripts,
  addStylesheet: addStylesheet,
  addStylesheets: addStylesheets,
  cookies: cookies,
  copyText: copyText,
  deepAssign: deepAssign,
  deepEqual: deepEqual,
  EventDispatcher: EventDispatcher,
  fillAddress: fillAddress,
  focusAfter: focusAfter,
  hyperscript: hyperscript,
  ModalAjax: ModalAjax,
  ModalPrompt: ModalPrompt,
  ModalShow: ModalShow,
  readdScripts: readdScripts,
  restoreScrollPosition: restoreScrollPosition,
  scrollTo: scrollTo,
  trapFocus: trapFocus
};
if (!window.util) {
  window.util = util;
} else {
  window.util = Object.assign(window.util, util);
}

// Store current script.
const scriptElement = document.currentScript;

// Load elements that need to be loaded on interactive.
onInteractive(() => {
  NCShortenText();
  NCPreviewImages();
  NCLoad('interactive');

  // Listen to changes on the DOM and fire feedback when elements have changed.
  const mutationAddsImage = mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          // If it is an image or contains an image.
          if (node.tagName === 'IMG' || node.querySelector('img')) {
            return true;
          }
        }
      }
    }
  };
  const observer = new MutationObserver((mutationList, observer) => {
    let imageAdded = false;
    for (const mutation of mutationList) {
      if (mutationAddsImage(mutation)) {
        imageAdded = true;
        break;
      }
    }
    if (imageAdded) {
      NCPreviewImages();
    }

    // TODO: Also check for modals etc. to be added dynamically.
  });
  // Start observing the body for changes.
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Setup selectors.
  const selectorModalAjax = 'a.showAjax,a.show-ajax,button.show-ajax,a[href$="&ajaxModal=1"],a[href$="?ajaxModal=1"]';
  const selectorModalShow = 'a.show-modal,button.show-modal';
  const selectorPopover = '[data-toggle="popover"]';
  const selectorModalPrompt = 'a.show-prompt,button.show-prompt';
  const selectorTooltip = '[data-toggle="tooltip"]';

  // Create singletons.
  window.modalAjax = window.ajaxModal = new ModalAjax(selectorModalAjax, {
    language: scriptElement.getAttribute('data-language-code')
  });
  window.modalShow = new ModalShow(selectorModalShow, {
    language: scriptElement.getAttribute('data-language-code')
  });
  window.modalPrompt = new ModalPrompt(selectorModalPrompt, {
    language: scriptElement.getAttribute('data-language-code')
  });

  // Setup Popover.
  const popoverElements = $(selectorPopover);
  if (popoverElements.popover) {
    popoverElements.popover({
      container: 'body'
    });
  }

  // Setup Tooltips.
  const tooltipElements = $(selectorTooltip);
  if (tooltipElements.tooltip) {
    tooltipElements.tooltip({
      container: 'body'
    });
  }
  const tooltipButtons = Array.from(document.querySelectorAll(selectorTooltip));
  const setupTooltipButton = button => {
    button.addEventListener('click', () => {
      const tooltipElements = $(button);
      if (tooltipElements.tooltip) {
        tooltipElements.tooltip('hide');
      }
    });
  };
  for (let i = 0; i < tooltipButtons.length; i++) {
    setupTooltipButton(tooltipButtons[i]);
  }

  // Close popover if clicked outside them or a modal button or link inside them.
  document.body.addEventListener('click', function (event) {
    const isModal = !!event.target.closest(window.modalAjax.selector) || !!event.target.closest(window.modalPrompt.selector);
    // Don't dismiss if a popover trigger was clicked and an ajax link was not clicked.
    if (!isModal && event.target.closest(selectorPopover)) {
      return;
    }

    // Scan all popovers and exit any that have been clicked outside of.
    const popovers = document.querySelectorAll('.popover');
    for (let i = 0; i < popovers.length; i++) {
      const popover = popovers[i];
      if (isModal || !popover.contains(event.target)) {
        const popoverElements = $(popover);
        if (popoverElements.popover) {
          popoverElements.popover('hide');
        }
      }
    }
  }, {
    capture: true,
    passive: true
  });

  // Run accessibility functions.
  NCAccessibilityFontSize();
  NCAccessibilityHighContrast();
  whappieHelper();
  storeScrollPosition();
});
onComplete(() => {
  // Run anchor offset-er.
  NCOffsetAnchors();

  // Load elements that need to be loaded on complete.
  NCLoad('complete');
  // Apply additional accessibility handling.
  NCAccessibilityMenu();
  // Run equal height function.
  NCEqual();
  // Setup elements that need to be intersected.
  NCIntersect();
});